import {
  assignmentTypeColumnDefinition,
  assignmentColumnDefinition,
  descriptionColumnDefinition,
  businessColumnDefinition,
  countryDescriptionColumnDefinition,
  connectionNameColumnDefinition,
  businessUnitColumnDefinition,
  businessUnitDescriptionColumnDefinition,
  companyCodeColumnDefinition,
  companyCodeDescriptionColumnDefinition,
  allDescriptionColumnDefinition,
} from '../columnDefinitions';
import {
  currentAssignmentsAssignColumnDefinitionFactory,
} from '../columnDefinitionGenerators';

import { assignmentTypes } from '../../shared/authorization/assignmentTypes';

const mapToValues = assignments => assignments.map(({ assignmentCode }) => assignmentCode);

export const specialTypeValueFormatter = ({ value }) => value === 'SpecialTypeAL' ? '' : value;

export default ({
  checkedAssignments,
  checkedBusinesses,
  checkedCountryCodes,
  checkedConnections,
  checkedBusinessUnits,
  checkedCompanyCodes,
  checkedAll,

  allBusinessesChecked,
  allCountryCodesChecked,
  allConnectionsChecked,
  allBusinessUnitsChecked,
  allCompanyCodesChecked,

  checkAssignment,
  checkAll,
  readOnly,
}) => {
  const currentAssignmentsColumnDefs = [
    currentAssignmentsAssignColumnDefinitionFactory({
      field: 'value',
      onChange: checkAssignment,
      checkedValues: mapToValues(checkedAssignments),
      assignmentType: 'ASSIGNMENT',
      readOnly,
    }),
    assignmentTypeColumnDefinition,
    assignmentColumnDefinition,
    {
      ...descriptionColumnDefinition,
      field: 'label',
      valueFormatter: specialTypeValueFormatter,
    },
  ];

  const businessColumnDefs = [
    currentAssignmentsAssignColumnDefinitionFactory({
      field: 'businessCode',
      onChange: checkAssignment,
      checkAll,
      allChecked: allBusinessesChecked,
      checkedValues: mapToValues(checkedBusinesses),
      assignmentType: assignmentTypes.BUSINESSES,
      readOnly,
    }),
    businessColumnDefinition,
  ];

  const countriesColumnDefs = [
    currentAssignmentsAssignColumnDefinitionFactory({
      field: 'countryCode',
      onChange: checkAssignment,
      checkAll,
      allChecked: allCountryCodesChecked,
      checkedValues: mapToValues(checkedCountryCodes),
      assignmentType: assignmentTypes.COUNTRIES,
      readOnly,
    }),
    countryDescriptionColumnDefinition,
  ];

  const connectionsColumnDefs = [
    currentAssignmentsAssignColumnDefinitionFactory({
      field: 'connectionName',
      onChange: checkAssignment,
      checkAll,
      allChecked: allConnectionsChecked,
      checkedValues: mapToValues(checkedConnections),
      assignmentType: assignmentTypes.CONNECTIONS,
      readOnly,
    }),
    connectionNameColumnDefinition,
  ];

  const businessUnitsColumnDefs = [
    currentAssignmentsAssignColumnDefinitionFactory({
      field: 'businessUnit',
      onChange: checkAssignment,
      checkAll,
      allChecked: allBusinessUnitsChecked,
      checkedValues: mapToValues(checkedBusinessUnits),
      assignmentType: assignmentTypes.BUSINESS_UNITS,
      readOnly,
    }),
    businessUnitColumnDefinition,
    { ...businessUnitDescriptionColumnDefinition, headerName: 'Description' },
  ];

  const companyCodesColumnDefs = [
    currentAssignmentsAssignColumnDefinitionFactory({
      field: 'companyCode',
      onChange: checkAssignment,
      checkAll,
      allChecked: allCompanyCodesChecked,
      checkedValues: mapToValues(checkedCompanyCodes),
      assignmentType: assignmentTypes.COMPANY_CODES,
      readOnly,
    }),
    companyCodeColumnDefinition,
    companyCodeDescriptionColumnDefinition,
  ];

  const allDataTypeColumnDefs = [
    currentAssignmentsAssignColumnDefinitionFactory({
      field: 'allCode',
      onChange: checkAssignment,
      checkedValues: mapToValues(checkedAll),
      assignmentType: assignmentTypes.ALL,
      readOnly,
    }),
    allDescriptionColumnDefinition,
  ];

  return {
    currentAssignmentsColumnDefs,
    businessColumnDefs,
    countriesColumnDefs,
    connectionsColumnDefs,
    businessUnitsColumnDefs,
    companyCodesColumnDefs,
    allDataTypeColumnDefs,
  };
};
